<template>
  <b-container v-if="latestUpdates.length">
    <b-row class="cc-updates-title">
      <b-col>
        <p>LATEST CC UPDATES</p>
      </b-col>
    </b-row>

    <b-row
      v-for="(post, index) in latestUpdates"
      :key="index"
      class="cc-updates-container"
    >
      <b-col cols="2">
        <img :src="$lodash.get(post, 'user_details.prof_pic')" class="cc-updates-img" />
      </b-col>
      <b-col cols="10">
        <router-link
          :to="{
            name: 'MemberWall',
            params: { customerId: $lodash.get(post,'user_details.customer_id')},
          }"
        >
          <p class="cc-updates-name">{{ $lodash.get(post,'user_details.name') }}</p>
        </router-link>
        <p v-if="post.content" class="cc-updates-date">
          {{ post.content.slice(0, 35) }}...
        </p>
      </b-col>
    </b-row>

    <b-row>
      <router-link
        :to="{
          name: 'CompanyWall',
          params: { companyId: 80 },
        }"
        class="all-latestUpdates button"
        exact
      >
        <button class="btn-def">All CC Updates</button>
      </router-link>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'LatestCcUpdates',
  props: {},
  data() {
    return {
      latestUpdates: [],
    };
  },
  async mounted() {
    const options = {
      companyId: 80,
      startDate: moment(new Date().toUTCString()).subtract(1, 'months').format('L'),
      endDate: moment(new Date().toUTCString()).format('L'),
    };
    const allUpdates = await this.fetchLatestCcUpdates(options);
    this.latestUpdates = allUpdates.results;
  },
  methods: {
    ...mapActions({
      fetchLatestCcUpdates: 'posts/fetchLatestCcUpdates',
    }),
  },
};
</script>

<style scoped>
.btn-def {
  color: white;
  font-size: 15px;
  text-align: center;
  border: solid 1px #bd9d5f;
  background-color: #bd9d5f;
  width: 100%;
  height: 37px;
  border-radius: 0 0 10px 10px;
}
.cc-updates-container {
  background-color: white;
  padding: 15px 0 15px 5px;
  margin-bottom: 1px;
}
.cc-updates-title {
  background-color: white;
  padding: 13px;
  margin-bottom: 1px;
  border-radius: 0 10px 0 0;
}
.to-booked-event {
  cursor: pointer;
}

.cc-updates-title p {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0;
}
.cc-updates-img {
  height: 40px;
  width: 40px;
}
.all-latestUpdates {
  width: 100%;
}
.cc-updates-name {
  font-family: Arial;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  margin-bottom: 4px;
}
.cc-updates-date {
  font-family: Arial;
  font-size: 11px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  margin-bottom: 4px;
}
</style>
